
import React, { Component } from 'react';
import { getWebsiteContent } from '../fetchJSON';

class EnglishHub extends Component {
    constructor() {
        super();
        this.state = { content: null }
    }

    componentWillMount() {
        var that = this;

        getWebsiteContent('EnglishHub', function (data) {
            that.setState({ content: data[0].html });
        });

    }
    render() {
        if (this.state.content) {
            var content = this.state.content;
        }
        return (
            <section>
                <header id="page-title">
                    <div className="container">
                        <h1>English Hub</h1>
                    </div>
                </header>
                <section className="container">
                    <div className="coi-xs-12 page-html" dangerouslySetInnerHTML={{ __html: content }} />
                </section>
            </section>
        );
    }
}

export default EnglishHub;
